import React, { useState, useEffect } from "react";
import { setPayloadData } from "@store/slices/globalState";
import { setAnalytics } from "@actions/setAnalyticsData";
import { TabContainer, TabItem, TabIcon, TabText, TabDivider } from "./styles";
import ImageContainer from "@components/imageContainer";
import { executeActions } from "@utils/index";

interface Tab {
  id: string;
  label: string;
  icon: "car" | "family";
  isActive?: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
  actions?: { on_tab_change?: Array<any>, vehicle_tab_selected?: Array<any>, family_tab_selected?: Array<any> };
}

const TabNavigation: React.FC<TabNavigationProps> = ({
  tabs = [],
  actions
}) => {
  const [activeTab, setActiveTab] = useState(
    tabs.find(tab => tab.isActive)?.id || tabs[0]?.id 
  );
  const { on_tab_change, vehicle_tab_selected, family_tab_selected } = actions || {};

  useEffect(() => {
    if (activeTab) {
      setPayloadData({ selected_tab: activeTab });
      setAnalytics({ selected_tab: activeTab });
    }
  }, [activeTab]);

  const handleTabClick = (tabId: string) => {
    if (tabId === activeTab) return;
    setActiveTab(tabId);

    on_tab_change?.forEach(action => {
      if (typeof action.funCall === "function") {
        action.funCall({ ...action.args, selectedTab: tabId });
      }
    });

    if (tabId === "family_tab") {
      executeActions(family_tab_selected);
      setTimeout(() => {
        const el =
          document.getElementById("add_on_node_page_container_famliy") ||
          document.getElementById("for_your_family_image");
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
        else window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
      }, 200);
    }
    else if (tabId === "car_tab") {
      executeActions(vehicle_tab_selected);
    }
  };

  const renderIcon = (icon: string, active: boolean) => {
    const style = { filter: active ? "brightness(0) invert(1)" : "none" };
    const icons: Record<string, string> = {
      car: "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-addons/carImg.svg",
      family: "https://storefront-consumer-assets.s3.ap-south-1.amazonaws.com/static/sdui-addons/family.svg"
    };
    return icons[icon] ? <ImageContainer imgSrc={icons[icon]} height={20} width={20} alt={icon} style={style} /> : null;
  };

  return (
    <TabContainer>
      {tabs.map((tab, i) => {
        const isActive = tab.id === activeTab;
        return (
          <React.Fragment key={tab.id}>
            <TabItem isActive={isActive} onClick={() => handleTabClick(tab.id)}>
              <TabIcon isActive={isActive}>{renderIcon(tab.icon, isActive)}</TabIcon>
              <TabText isActive={isActive}>{tab.label}</TabText>
            </TabItem>
            {i < tabs.length - 1 && <TabDivider />}
          </React.Fragment>
        );
      })}
    </TabContainer>
  );
};

export default TabNavigation;
